/*
 * Fragment in Fennec can used in Mothership, Stepmother, Westeros and Essos layout.
 *
 * Mothership, Westeros and Essos layout provide secure client wrapper on
 * window.API object
 *
 * But Stepmother layout do not provide window.APP, window.USER nor window.API.
 * It only provide window.blGlobal
 *
 */

import secureClient from '@bukalapak/secure-client';

function getSecureClientWrapper() {
  try {
    return global.API.wrap;
  } catch (e) {
    // support stepmother layout
    if (global.blGlobal && global.document.querySelector('.js-secure-client')) {
      const { blGlobal } = global;
      const $authForm = global.document.querySelector('.js-secure-client');

      const atmInstance = new secureClient.AccessTokenManager({
        userId: blGlobal.user.id,
        env: blGlobal.application.env,
        authEndpoint: $authForm.getAttribute('action'),
        appId: $authForm.querySelector('input[name=application_id]').value,
        authToken: $authForm.querySelector('input[name=authenticity_token]')
          .value,
      });

      secureClient.wrapSecureClientInterface.setup(
        atmInstance,
        blGlobal.application.api_url,
      );
    }

    return secureClient.wrapSecureClientInterface;
  }
}

const secureClientWrapper = getSecureClientWrapper();
export default secureClientWrapper;
